<template>
	<div class="display-flex flex-column width-100">
		<div :key="i" v-for="(section, i) in projectsBySection">
			<template v-if="section.items.length > 0">
				<div
					v-if="!section.hideTitle"
					class="section-header-container display-flex flex-row flex-align-center mt-4 mb-1 flex-justify-space-between"
				>
					<div class="display-flex flex-row flex-align-center">
						<div class="section-title">{{ section.title }}</div>
						<component v-if="section.infoComponent" :is="section.infoComponent" v-bind="section.infoComponentProps || {}" class="ml-2" />
					</div>
					<component
						class="suffix-component"
						:is="section.suffixComponent"
						v-if="section.suffixComponent"
						v-bind="section.suffixComponentProps || {}"
					/>
				</div>
				<ProjectMenuItem
					class="mb-1"
					:key="project.id"
					v-on="$listeners"
					:project="project"
					:hideIcon="section.hideIcon"
					v-for="project in section.items"
				/>
			</template>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import ProjectMenuItem from '@/components/ProjectMenu/ProjectMenuItem.vue';
import ProjectMenuSpacesInfo from '@/components/ProjectMenu/ProjectMenuSpacesInfo.vue';
import ProjectsSectionHeaderSettingsDropdown from '@/components/ProjectMenu/ProjectsSectionHeaderSettingsDropdown.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { getProject, projectsList, projectHasPermission } from '@/store/modules/projects/getters';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import ProjectService from '@/utils/projects-service';
import {
	ALL_PROJECTS_VIRTUAL_ID,
	ALL_PROJECTS_VIRTUAL_TITLE,
	PROJECTS_SHARED_WITH_ME_VIRTUAL_ID,
	PROJECTS_SHARED_WITH_ME_VIRTUAL_TITLE,
} from '@/utils/projects.const';
export default {
	name: 'ProjectTabMenuContent',
	components: {
		ProjectMenuItem,
		ProjectsSectionHeaderSettingsDropdown,
	},
	props: {},
	computed: {
		...mapGetters(['user']),
		...mapGetters([getProject.fullPath, projectsList.fullPath, selectedProjectId.fullPath, projectHasPermission.fullPath]),
		projectIdentifier() {
			const identifier = this[selectedProjectId.fullPath];
			return isNaN(identifier) ? identifier.toLowerCase() : identifier;
		},
		projects() {
			const virtualProjects = [
				{
					title: ALL_PROJECTS_VIRTUAL_TITLE,
					description: 'All spaces',
					id: ALL_PROJECTS_VIRTUAL_ID,
				},
				{
					title: PROJECTS_SHARED_WITH_ME_VIRTUAL_TITLE,
					description: 'For use only',
					id: PROJECTS_SHARED_WITH_ME_VIRTUAL_ID,
				},
			];
			const realProjects = this[projectsList.fullPath];
			return [...virtualProjects, ...realProjects];
		},
		allProjectsWithAccess() {
			return this.projects.filter((x) => !ProjectService.isSpaceWithoutAccess(x));
		},
		projectsBySection() {
			const everything = this.allProjectsWithAccess.find((x) => x.title === ALL_PROJECTS_VIRTUAL_TITLE);
			const sharedWithMe = this.allProjectsWithAccess.find((x) => x.title === PROJECTS_SHARED_WITH_ME_VIRTUAL_TITLE);
			const personalProject = this.allProjectsWithAccess.find((x) => ProjectService.isMyPersonalProject(x, this.user)); // this is a find, instead of filter, because we limited the personal projects to be only one
			const workspaceProjects = this.allProjectsWithAccess.filter((x) => ProjectService.isWorkspaceProject(x));
			const personalAndCollaborativeSpaces = personalProject ? [personalProject, ...workspaceProjects] : workspaceProjects;

			return [
				{
					hideTitle: true,
					items: [everything, { ...sharedWithMe, additionalInfo: 'for use only' }],
				},
				{
					title: 'Spaces',
					infoComponent: ProjectMenuSpacesInfo,
					items: personalAndCollaborativeSpaces,
					suffixComponent: ProjectsSectionHeaderSettingsDropdown,
				},
			];
		},
	},
	methods: {
		createNewProject() {
			AppDialogManagerService.openNewProjectDialog();
		},
	},
};
</script>

<style scoped lang="scss">
.section-title {
	font-size: 11px;
	color: #8f95ab;
	padding-left: 6px;
	letter-spacing: 0px;
}
.section-header-container {
	&:hover {
		background: #f4f5f66c;
		.suffix-component {
			opacity: 1;
			transition: 0.2s;
		}
	}
}
.suffix-component {
	opacity: 0;
	transition: 0.2s;
}
</style>
